import { useQuery } from 'react-query';

import { getResourceEmbedStatus, ResourceEmbedStatus } from 'services/resources';

// The result of the server's frame-restriction check for an Embeddable URL. A failed
// lookup resolves to undefined so the viewer keeps its default of leading with the embed.
export default function useResourceEmbedStatus(slug: string, options?: { enabled?: boolean }) {
  return useQuery<ResourceEmbedStatus | undefined>(
    `resource-${slug}-embed-status`,
    () => getResourceEmbedStatus(slug).then((response) => response.data?.status),
    {
      enabled: options?.enabled,
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 60000,
    }
  );
}
